// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_e8l","cls2":"DebugPage-cls2_lXc DebugPage-cls1_e8l"};